var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4818 5.53243L28.4667 9.51741M27.0437 2.0218L16.2633 12.8021C15.7063 13.3584 15.3264 14.0671 15.1716 14.8389L14.1758 19.8234L19.1603 18.8257C19.9321 18.6714 20.6398 18.293 21.197 17.7358L31.9774 6.9555C32.3013 6.63155 32.5583 6.24696 32.7336 5.8237C32.9089 5.40044 32.9992 4.94679 32.9992 4.48865C32.9992 4.03051 32.9089 3.57686 32.7336 3.1536C32.5583 2.73034 32.3013 2.34575 31.9774 2.0218C31.6534 1.69785 31.2688 1.44088 30.8456 1.26556C30.4223 1.09024 29.9687 1 29.5105 1C29.0524 1 28.5987 1.09024 28.1755 1.26556C27.7522 1.44088 27.3676 1.69785 27.0437 2.0218Z",
    stroke: "#7C8DB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2356 23.5874V29.2345C29.2356 30.233 28.8389 31.1906 28.1329 31.8966C27.4269 32.6026 26.4693 32.9993 25.4708 32.9993H4.76474C3.76627 32.9993 2.80869 32.6026 2.10267 31.8966C1.39664 31.1906 1 30.233 1 29.2345V8.52842C1 7.52994 1.39664 6.57237 2.10267 5.86634C2.80869 5.16031 3.76627 4.76367 4.76474 4.76367H10.4119",
    stroke: "#7C8DB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBills);
export default __webpack_public_path__ + "static/media/edit-bills.8e5e3e68da799413b902e2d85d013d81.svg";
export { ForwardRef as ReactComponent };